export const BOT_SERVICE_URL = process.env.NEXT_PUBLIC_BOT_SERVICE_URL || '';

export const GRAPH_API_URLS = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

export const BOT_SERVICE_API_URLS = {
    CHAT: '/api/conversations/chat',
};
